export default __webpack_public_path__ + "static/5-222f78b12d632218b1b2c501e4a37230.png";